import { useTranslation } from "react-i18next";
import { FC, Props } from "./typings";
import styles from "./styles.module.scss";
import { useState, useEffect } from "react";

import CloseIcon from "assets/icons/close.svg?react";
import classNames from "classnames";
import Button from "components/Button";
import { EClientData, IClientData } from "dto/IClient";
import EditIcon from "assets/icons/edite.svg?react";
import CopyIcon from "assets/icons/copye.svg?react";
import { formatToFormat } from "utils/formatToFormat";
import EmailIcon from "assets/icons/aemail.svg?react";
import LetterIcon from "assets/icons/new_parcel.svg?react";
import AdeIcon from "assets/icons/ade.svg?react";
import InputInline from "components/InputInline";
import { Tooltip } from "@mui/material";

const CaseParticipantDataRow = ({
  data,
  handleSave,
}: // handleChangeIsMain,
// handleCancel,
{
  data: IClientData;
  handleSave(value: string): void;
  // handleChangeIsMain(): void;
  // handleCancel(): void;
}) => {
  const { t } = useTranslation();
  const [value, setValue] = useState(data.Value);
  const [isInEditMode, setIsInEditMode] = useState(false);

  useEffect(() => {
    setValue(data?.Value);
  }, [data]);

  if (isInEditMode) {
    return (
      <div className={styles.edit}>
        <InputInline
          value={value}
          onChange={(v) => {
            setValue(v);
            handleSave(v);
            setIsInEditMode(false);
          }}
          onCancel={() => setIsInEditMode(false)}
        ></InputInline>
      </div>
    );
  }

  return (
    <div className={styles.valueWrapper}>
      <div
        title={value}
        className={classNames(styles.name, !value ? styles.empty : null)}
      >
        {data.Type === EClientData.PHONE
          ? formatToFormat(value, "### ### ###")
          : value ?? "..."}
      </div>
      <div className={styles.options}>
        {!value && (
          <Button
            text={t("common.add")}
            className={styles.addButton}
            onClick={() => setIsInEditMode(true)}
          />
        )}
        {value && (
          <Tooltip title={t("common.edit")}>
            <div>
              <EditIcon
                className={styles.iconButton}
                onClick={() => setIsInEditMode(true)}
              />
            </div>
          </Tooltip>
        )}
        {value && (
          <Tooltip title={t("common.copy")}>
            <div>
              <CopyIcon
                className={styles.iconButton}
                onClick={() => {
                  navigator.clipboard.writeText(value ?? "");
                }}
              />
            </div>
          </Tooltip>
        )}
      </div>
    </div>
  );
};

const CaseParticipantEditorModal: FC<Props> = ({ toggle, source, update }) => {
  const [email, setEmail] = useState<IClientData>({
    IsMain: true,
    Type: EClientData.EMAIL,
    Value: source.Email,
  });
  const [ade, setAde] = useState<IClientData>({
    IsMain: true,
    Type: EClientData.eaddress,
    Value: source.EDeliveryAddress,
  });
  const [address, setAddress] = useState<IClientData>({
    IsMain: true,
    Type: EClientData.ADDRESS,
    Value: source.Address,
  });
  const [epuap, setEpuap] = useState<IClientData>({
    IsMain: true,
    Type: EClientData.epuapaddress,
    Value: source.EpuapAddress,
  });

  return (
    <div className={styles.wrapper}>
      <div className={styles.title}>
        <div className={styles.titleText}>{source.Label}</div>
        <CloseIcon
          onClick={() => {
            toggle(false);
          }}
          className={styles.closeIcon}
        />
      </div>

      <div className={styles.inputs}>
        <div className={styles.row}>
          <div className={styles.icon}>
            <LetterIcon></LetterIcon>
          </div>
          <div className={styles.editor}>
            <CaseParticipantDataRow
              data={address}
              handleSave={(v) => {
                setAddress({ ...address, Value: v }), (source.Address = v);
                update(source);
              }}
            ></CaseParticipantDataRow>
          </div>
        </div>
        <div className={styles.row}>
          <div className={styles.icon}>
            <EmailIcon></EmailIcon>
          </div>
          <div className={styles.editor}>
            <CaseParticipantDataRow
              data={email}
              handleSave={(v) => {
                setEmail({ ...email, Value: v });
                source.Email = v;
                update(source);
              }}
            ></CaseParticipantDataRow>
          </div>
        </div>
        <div className={styles.row}>
          <div className={styles.icon}>
            <AdeIcon></AdeIcon>
          </div>
          <div className={styles.editor}>
            <CaseParticipantDataRow
              data={ade}
              handleSave={(v) => {
                setAde({ ...ade, Value: v });
                source.EDeliveryAddress = v;
                update(source);
              }}
            ></CaseParticipantDataRow>
          </div>
        </div>
        <div className={styles.row}>
          <div className={styles.icon}>
            <AdeIcon></AdeIcon>
          </div>
          <div className={styles.editor}>
            <CaseParticipantDataRow
              data={epuap}
              handleSave={(v) => {
                setEpuap({ ...epuap, Value: v });
                source.EpuapAddress = v;
                update(source);
              }}
            ></CaseParticipantDataRow>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CaseParticipantEditorModal;
